uvex-event-list {
  .event-headline {
    text-align: center;
    padding: 1rem 0;
    border-top: 2px solid var(--brand-primary, #ff6600);
    border-bottom: 2px solid var(--brand-primary, #ff6600);
  }
}
